class HeaderSearch extends HTMLElement {
    constructor() {
      super();
  
      this.isOpen = false;

      this.decoration = this.querySelector('#desk-predictive-decorator');
      this.input = this.querySelector('.nav-desk-search');
      this.searchResults = this.querySelector('.nav-desk-results');


      // botch for mobile toggle :(( quicker to have toggle element external to header-search
      this.mobileToggle = document.querySelector('.nav-mobile-search-toggle');
      this.container = document.querySelector('.nav-mobile-search-container');

      this.mobileToggle.addEventListener('click', this.debounce(() => {
        this.open();
        this.input.focus();
      }, 200).bind(this));

  
      this.input?.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 200).bind(this));

      this.input?.addEventListener('focus', this.debounce(() => {

        if (this.input.value.trim() !== "") this.open();

      }, 200).bind(this));

      this.input?.addEventListener('focusout', this.debounce(() => {

        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        })

      }, 200).bind(this));
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`${routes.predictive_search_url}?q=${searchTerm}&section_id=header-search`)
        .then((response) => {

          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-search').innerHTML;
          this.searchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.isOpen = true;
      this.searchResults?.classList.remove("fade-out");
      this.decoration?.classList.remove("fade-out");

      if (this.container?.classList.contains("closed")) {
        this.container?.classList.remove("closed");
      }
    }
  
    close() {
      this.isOpen = false;
      this.searchResults?.classList.add("fade-out");
      this.decoration?.classList.add("fade-out");

      if (!this.container?.classList.contains("closed")) {
        this.container?.classList.add("closed");
      }
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  customElements.define('header-search', HeaderSearch);